export const EXTENDED_WAITING_SERVICE_TYPE = "extended_waiting_time";

export const EXTENDED_WAITING_UNIT_PRICES = {
  alphard: 2500,
  hiace: 3500,
  premium_hiace: 5000,
};

export const normalizeWaitingVehicleType = (vehicleType) => ({
  alpha: "alphard",
  luxury_hiace: "premium_hiace",
}[vehicleType] || vehicleType || "alphard");

export const getExtendedWaitingUnitPrice = (vehicleType) =>
  EXTENDED_WAITING_UNIT_PRICES[normalizeWaitingVehicleType(vehicleType)] || 0;

export const getBaseFreeWaitingMinutes = (pickupArea) => {
  const value = String(pickupArea || "").toLowerCase();
  return value.includes("airport") || value.includes("port") ? 90 : 30;
};

export const getExtendedWaitingQuantity = (extraServices = []) =>
  Number(extraServices.find((item) => item.service_type === EXTENDED_WAITING_SERVICE_TYPE)?.quantity || 0);

export const setExtendedWaitingQuantity = (extraServices = [], quantity = 0) => {
  const rest = extraServices.filter((item) => item.service_type !== EXTENDED_WAITING_SERVICE_TYPE);
  const safeQuantity = Math.max(0, Math.min(6, Number(quantity) || 0));
  if (!safeQuantity) return rest;
  return [...rest, {
    service_type: EXTENDED_WAITING_SERVICE_TYPE,
    quantity: safeQuantity,
    status: "approved",
  }];
};

export const EXTENDED_WAITING_COPY = {
  zh: {
    title: "延长等待时间",
    none: "不延长",
    add: (minutes) => `+${minutes}分钟`,
    included: (minutes) => `原本已包含${minutes}分钟免费等待`,
    summary: (added, base, total, price) => `增加${added}分钟 · 原含${base}分钟 · 合计等待${total}分钟 · ¥${price.toLocaleString()}`,
  },
  ja: {
    title: "待機時間の延長",
    none: "延長なし",
    add: (minutes) => `+${minutes}分`,
    included: (minutes) => `通常料金には${minutes}分の無料待機が含まれています`,
    summary: (added, base, total, price) => `追加${added}分 · 無料${base}分 · 合計待機${total}分 · ¥${price.toLocaleString()}`,
  },
  en: {
    title: "Extended waiting time",
    none: "No extension",
    add: (minutes) => `+${minutes} min`,
    included: (minutes) => `${minutes} minutes of free waiting is already included`,
    summary: (added, base, total, price) => `Add ${added} min · Included ${base} min · Total wait ${total} min · ¥${price.toLocaleString()}`,
  },
  es: {
    title: "Tiempo de espera adicional",
    none: "Sin extensión",
    add: (minutes) => `+${minutes} min`,
    included: (minutes) => `Ya se incluyen ${minutes} minutos de espera gratuita`,
    summary: (added, base, total, price) => `Añadir ${added} min · Incluidos ${base} min · Espera total ${total} min · ¥${price.toLocaleString()}`,
  },
};

export const getExtendedWaitingDisplay = (service, order, language = "zh") => {
  const copy = EXTENDED_WAITING_COPY[language] || EXTENDED_WAITING_COPY.zh;
  const quantity = Math.max(1, Number(service?.quantity) || 1);
  const added = quantity * 30;
  const base = getBaseFreeWaitingMinutes(order?.pickup_area);
  const unitPrice = Number(service?.price) || getExtendedWaitingUnitPrice(order?.vehicle_type);
  return copy.summary(added, base, base + added, unitPrice * quantity);
};
